const getKeyFromS3Url = (url: string) => {
    const [s3Url] = url.split("?");
    const index = s3Url.indexOf("aws.com/");
    return s3Url.slice(index + 8);
};

export default getKeyFromS3Url;
